import React from 'react';

const Four0Four = () => {
    return (
        <h1>Sorry mate, page not found.</h1>
    );
};

export default Four0Four;